// src/store/mappers/organization/seats.mapper.ts
import type { SeatSummaryDTO, SeatBucketDTO } from '@/types/organization.dtos';
import type { SeatBucket } from '@/types/organization.types';

/**
 * Map SeatBucketDTO → SeatBucket (app type)
 */
function mapSeatBucket(dto: SeatBucketDTO): SeatBucket {
  return {
    available: dto.total,
    active: dto.active,
    new: dto.new,
    inactive: dto.inactive,
  };
}

/**
 * Map SeatSummaryDTO → { internalSeats, externalSeats }
 */
export function mapSeatSummaryDTOToSeats(dto: SeatSummaryDTO): {
  internalSeats: SeatBucket;
  externalSeats: SeatBucket;
} {
  return {
    internalSeats: mapSeatBucket(dto.internal),
    externalSeats: mapSeatBucket(dto.external),
  };
}
